var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.291 64c-5.512 0-10-4.485-10-10a2 2 0 0 1 4 0c0 3.31 2.693 6 6 6s6-2.69 6-6a2 2 0 0 1 4 0c0 5.515-4.488 10-10 10z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.291 56h-44a4.672 4.672 0 0 1-4.666-4.666c0-1.366.595-2.66 1.632-3.547.067-.059.139-.112.213-.16a17.922 17.922 0 0 0 6.155-13.52v-7.44C10.625 16.372 19.001 8 29.291 8c.427 0 .889.008 1.315.08a2 2 0 0 1 1.645 2.301 2.01 2.01 0 0 1-2.3 1.643c-.214-.035-.449-.024-.66-.024-8.085 0-14.666 6.579-14.666 14.666v7.44c0 6.443-2.824 12.54-7.741 16.723-.04.032-.075.062-.118.09a.66.66 0 0 0-.141.415c0 .362.304.666.667.666h44a.674.674 0 0 0 .666-.666.637.637 0 0 0-.143-.414c-.04-.03-.075-.059-.115-.09a21.927 21.927 0 0 1-7.742-16.724V31.2a2 2 0 0 1 4 0v2.906c0 5.193 2.243 10.11 6.163 13.529.072.048.141.098.205.155a4.652 4.652 0 0 1 1.633 3.544A4.672 4.672 0 0 1 51.29 56z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.959 26.666c-7.353 0-13.334-5.98-13.334-13.332C34.625 5.98 40.606 0 47.959 0 55.31 0 61.29 5.981 61.29 13.334c0 7.352-5.98 13.332-13.332 13.332zm0-22.666c-5.148 0-9.334 4.187-9.334 9.334 0 5.146 4.187 9.332 9.334 9.332 5.146 0 9.332-4.186 9.332-9.332C57.291 8.187 53.105 4 47.96 4z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.88b3de689d491c7440406450c291f8b8.svg";
export { ForwardRef as ReactComponent };